<template>
  <div class="group">
    <div class="title">{{group.name}}</div>
    <hot-key-item 
      class="hot-key-item" 
      v-for="k in group.getKeyList()" 
      :key=k.id 
      :hotKey="k" 
      :customizable="group.customizable"
      @editing="editingHandler" 
      @refresh="$emit('refresh')" 
    />
  </div>
</template>

<script>
import hotKeyItem from './hotKeyItem.vue'
export default {
  components: { hotKeyItem },
  name: "hotKeyGroup",
  props: ["group"],
  methods: {
    editingHandler: function(isEditing) {
      // console.log("hotKeyGroup editing")
      this.$emit("editing", isEditing)
    }
  },
}
</script>

<style scoped>
.group {
  width: 16em;
}
.title {
  margin: 0.8em 0;
  text-transform: capitalize;
}
.hot-key-item {
  margin: 0 0 0.5em 0;
}
</style>
